import { render, staticRenderFns } from "./JoinRegionContainer.vue?vue&type=template&id=84b5b914"
import script from "./JoinRegionContainer.vue?vue&type=script&lang=js"
export * from "./JoinRegionContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports